import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import FlexWrap from './FlexWrap';
import ClientProvider from './client';
export default createDemo(import.meta.url, FlexWrap, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/flexbox/demos/flex-wrap/FlexWrap.tsx",
    "fileName": "FlexWrap.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport type { BoxProps } from '@mui/material/Box';\n\nfunction Item(props: BoxProps) {\n  const { sx = [], ...other } = props;\n  return (\n    <Box\n      sx={[\n        (theme) => ({\n          p: 1,\n          m: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        }),\n        ...[sx].flat(),\n      ]}\n      {...other}\n    />\n  );\n}\n\nexport default function FlexWrap() {\n  return (\n    <div style={{ width: '100%' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 3,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Box\n        sx={{\n          display: 'flex',\n          flexWrap: 'nowrap',\n          p: 1,\n          m: 1,\n          bgcolor: 'background.paper',\n          maxWidth: 300,\n          borderRadius: 1,\n        }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n        <Item>Item 4</Item>\n        <Item>Item 5</Item>\n        <Item>Item 6</Item>\n      </Box>\n      <Box\n        sx={{\n          display: 'flex',\n          flexWrap: 'wrap',\n          p: 1,\n          m: 1,\n          bgcolor: 'background.paper',\n          maxWidth: 300,\n          borderRadius: 1,\n        }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n        <Item>Item 4</Item>\n        <Item>Item 5</Item>\n        <Item>Item 6</Item>\n      </Box>\n      <Box\n        sx={{\n          display: 'flex',\n          flexWrap: 'wrap-reverse',\n          p: 1,\n          m: 1,\n          bgcolor: 'background.paper',\n          maxWidth: 300,\n          borderRadius: 1,\n        }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n        <Item>Item 4</Item>\n        <Item>Item 5</Item>\n        <Item>Item 6</Item>\n      </Box>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 91,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport type { BoxProps } from '@mui/material/Box';\n\nfunction Item(props: BoxProps) {\n  const { sx = [], ...other } = props;\n  return (\n    <Box\n      sx={[\n        (theme) => ({\n          p: 1,\n          m: 1,\n          bgcolor: 'grey.100',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        }),\n        ...[sx].flat(),\n      ]}\n      {...other}\n    />\n  );\n}\n\nexport default function FlexWrap() {\n  return (\n    <div style={{ width: '100%' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 3
        },
        "      <Box\n        sx={{\n          display: 'flex',\n          flexWrap: 'nowrap',\n          p: 1,\n          m: 1,\n          bgcolor: 'background.paper',\n          maxWidth: 300,\n          borderRadius: 1,\n        }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n        <Item>Item 4</Item>\n        <Item>Item 5</Item>\n        <Item>Item 6</Item>\n      </Box>\n      <Box\n        sx={{\n          display: 'flex',\n          flexWrap: 'wrap',\n          p: 1,\n          m: 1,\n          bgcolor: 'background.paper',\n          maxWidth: 300,\n          borderRadius: 1,\n        }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n        <Item>Item 4</Item>\n        <Item>Item 5</Item>\n        <Item>Item 6</Item>\n      </Box>\n      <Box\n        sx={{\n          display: 'flex',\n          flexWrap: 'wrap-reverse',\n          p: 1,\n          m: 1,\n          bgcolor: 'background.paper',\n          maxWidth: 300,\n          borderRadius: 1,\n        }}\n      >\n        <Item>Item 1</Item>\n        <Item>Item 2</Item>\n        <Item>Item 3</Item>\n        <Item>Item 4</Item>\n        <Item>Item 5</Item>\n        <Item>Item 6</Item>\n      </Box>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "totalLines": 91,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
